import { graphql, useStaticQuery } from 'gatsby';
import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import { device } from '../../utils/device';
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";


const Container = styled.section`
  display: flex;
  justify-content: center;

  @media ${device.laptopL} {
    flex-direction: column;
  }

  h1, h2, h3, h4 {
    margin: 0 0 10px 0;
    color: ${props => props.theme.colors.mediumBlue};
  }
`;

const LeftContainer = styled.div`
  padding: 70px 35px 70px 70px;
  width: 100%;
  max-width: 900px;
  min-height: calc(100vh - 647px);
  color: ${props => props.theme.colors.text.gray};

  @media ${device.laptopL} {
    padding: 50px 100px;
    max-width: 1100px;
    margin: auto;
  }
  @media ${device.laptop} {
    height: 100%;
    width: 100%;
    padding: 50px 100px;
  }
  @media ${device.tablet} {
    padding: 50px;
    p, li {
      font-size: 14px;
    }
  }
  @media ${device.mobileL} {
    padding: 30px 20px;
  }


  ul, ol {
    margin: 10px 10px 30px 50px;
    @media ${device.mobileL} {
      margin-left: 25px;
    }

    li {
      margin-bottom: 10px;
    }
  }
`;

const RightContainer = styled.div`
  padding: 70px 70px 70px 35px;
  width: 100%;
  max-width: 900px;
  h4 {
    text-align: center;
  }

  @media ${device.laptopL} {
    padding: 0px 100px 50px;
    max-width: 1100px;
    margin: auto;
  }
  @media ${device.tablet} {
    padding: 0 50px;
  }
  @media ${device.mobileL} {
    padding: 0px 20px;
  }
  @media ${device.mobileM} {
    padding: 0px 5px;
  }
`;

function RequestDemoContent() {
  const data = useStaticQuery(graphql`
    query RequestDemoContentQuery {
      strapiRequestDemo {
        content,
        calendarHeading,
        calendarIFrame
      }
  }
`);

 const { content, calendarHeading, calendarIFrame} = data.strapiRequestDemo;
 
 useEffect(() => {
  const meetings_script = document.createElement('script');
  meetings_script.setAttribute('src', 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js');
  document.body.appendChild(meetings_script);
 }, []);

  return (
    <>
      <Container>
        <LeftContainer>
          <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
        </LeftContainer>
        <RightContainer>
          <h4>{calendarHeading}</h4>
          <div className="meetings-iframe-container" data-src={calendarIFrame}></div>
        </RightContainer>
      </Container>
    </>
  );
}

export default RequestDemoContent;

